<template>
  <div class="fx_content">

    <div class="fenxi_con">
      <h1 class="title">30天经济效益</h1>
      <div class="paiming">
        <ul>
          <li :class="paiming.active == 1 ? 'on' : ''" @click="active(1)">
            入网数排名
          </li>
          <li :class="paiming.active == 2 ? 'on' : ''" @click="active(2)">
            节电费排名
          </li>
          <li :class="paiming.active == 3 ? 'on' : ''" @click="active(3)">
            基站备电稳定性排名
          </li>
        </ul>
      </div>
      <v-chart class="chart" :option="options" :autoresize="true" v-if="paiming.active == 1" />
      <v-chart class="chart" :option="options2" :autoresize="true" v-else-if="paiming.active == 2" />
      <v-chart class="chart" :option="options3" :autoresize="true" v-else-if="paiming.active == 3" />

    </div>
  </div>
</template>

<script>
import http from "@/api/http";
import { ref, onMounted, getCurrentInstance } from "vue";
import * as echarts from "echarts";
export default {
  name: "JingJi",
  components: {},
  props: {},
  setup() {
    let paiming = ref({
      active: 1,
    });

    //const xAxisData = data.map((item) => item.area_name);
    // const seriesData = data.map(
    //   (item) => `${item.cnt}元 （${(item.per * 100).toFixed(2)}%）`
    // );
    //const detailData = data.map((item) => item.cnt);
    //const totalSeriesData = data.map((item) => item.sum_cnt);
    const attackSourcesColor = [
      new echarts.graphic.LinearGradient(0, 1, 1, 1, [
        {
          offset: 0,
          color: "#8b2806",
        },
        {
          offset: 1,
          color: "#f03e00",
        },
      ]),
      new echarts.graphic.LinearGradient(0, 1, 1, 1, [
        {
          offset: 0,
          color: "#856f17",
        },
        {
          offset: 1,
          color: "#eaba15",
        },
      ]),
      new echarts.graphic.LinearGradient(0, 1, 1, 1, [
        {
          offset: 0,
          color: "#017778",
        },
        {
          offset: 1,
          color: "#01e3e5",
        },
      ]),
      new echarts.graphic.LinearGradient(0, 1, 1, 1, [
        {
          offset: 0,
          color: "#007d5b  ",
        },
        {
          offset: 1,
          color: "#00ecac",
        },
      ]),
    ];

    function rankBarColor(cData) {
      let tempData = [];
      cData.forEach((item, index) => {
        tempData.push({
          value: item,
          itemStyle: {
            color:
              index > 3 ? attackSourcesColor[3] : attackSourcesColor[index],
          },
        });
      });
      return tempData;
    }
    const options = ref({
      grid: {
        left: 50,
        right: 20,
        bottom: 90,
        top: 5,
        // grid 区域是否包含坐标轴的刻度标签。
        containLabel: false,
      },
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        //max: totalSeriesData[0],
        max: '',
      },
      yAxis: [
        {
          type: "category",
          // 是否是反向坐标轴
          inverse: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          //data: xAxisData,
          data: [],
          axisLabel: {
            padding: [0, 0, 20, 0],
            rich: {
              nt1: {
                color: "#fff",
                backgroundColor: "rgba(239,62,0,0.3)",
                borderColor: "#f03e00",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt2: {
                color: "#fff",
                backgroundColor: "rgba(233,186,21,0.3)",
                borderColor: "#eaba15",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt3: {
                color: "#fff",
                backgroundColor: "rgba(0,236,236,0.3)",
                borderColor: "#01e3e5",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt: {
                color: "#fff",
                backgroundColor: "rgba(0,237,173,0.3)",
                borderColor: "#00edad",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
            },
            formatter: function (value, index) {
              let idx = index + 1;
              if (idx <= 3) {
                return ["{nt" + idx + "|" + idx + "}"].join("\n");
              } else {
                return ["{nt|" + idx + "}"].join("\n");
              }
            },
          },
        },
        {
          //名称
          type: "category",
          // Y 轴相对于默认位置的偏移，在相同的 position 上有多个 Y 轴的时候有用。
          offset: -10,
          position: "left",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "left",
            // 文字垂直对齐方式，默认自动。
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          //data: xAxisData,
          data: [],
        },
        {
          //名称
          type: "category",
          offset: 0,
          position: "right",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "right",
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          data: [],
        },
      ],
      series: [
        {
          zlevel: 1,
          type: "bar",
          barWidth: 10,
          // barGap: 50,
          //data: rankBarColor(detailData),
          data: '',
          // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
          label: {
            show: false,
          },
        },
        {
          type: "bar",
          barWidth: 10,
          // 不同系列的柱间距离，为百分比（如 '30%'，表示柱子宽度的 30%）如果想要两个系列的柱子重叠，可以设置 barGap 为 '-100%'。这在用柱子做背景的时候有用。
          barGap: "-100%",
          // barMinHeight: 500,
          itemStyle: {
            normal: {
              color: "#134a61",
            },
          },
          //data: totalSeriesData,
          data: [],
        },
      ],
    });
    const options2 = ref({
      grid: {
        left: 50,
        right: 20,
        bottom: 90,
        top: 5,
        // grid 区域是否包含坐标轴的刻度标签。
        containLabel: false,
      },
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        //max: totalSeriesData[0],
        max: '',
      },
      yAxis: [
        {
          type: "category",
          // 是否是反向坐标轴
          inverse: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          //data: xAxisData,
          data: [],
          axisLabel: {
            padding: [0, 0, 20, 0],
            rich: {
              nt1: {
                color: "#fff",
                backgroundColor: "rgba(239,62,0,0.3)",
                borderColor: "#f03e00",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt2: {
                color: "#fff",
                backgroundColor: "rgba(233,186,21,0.3)",
                borderColor: "#eaba15",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt3: {
                color: "#fff",
                backgroundColor: "rgba(0,236,236,0.3)",
                borderColor: "#01e3e5",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt: {
                color: "#fff",
                backgroundColor: "rgba(0,237,173,0.3)",
                borderColor: "#00edad",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
            },
            formatter: function (value, index) {
              let idx = index + 1;
              if (idx <= 3) {
                return ["{nt" + idx + "|" + idx + "}"].join("\n");
              } else {
                return ["{nt|" + idx + "}"].join("\n");
              }
            },
          },
        },
        {
          //名称
          type: "category",
          // Y 轴相对于默认位置的偏移，在相同的 position 上有多个 Y 轴的时候有用。
          offset: -10,
          position: "left",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "left",
            // 文字垂直对齐方式，默认自动。
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          //data: xAxisData,
          data: [],
        },
        {
          //名称
          type: "category",
          offset: 0,
          position: "right",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "right",
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          data: [],
        },
      ],
      series: [
        {
          zlevel: 1,
          type: "bar",
          barWidth: 10,
          // barGap: 50,
          //data: rankBarColor(detailData),
          data: '',
          // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
          label: {
            show: false,
          },
        },
        {
          type: "bar",
          barWidth: 10,
          // 不同系列的柱间距离，为百分比（如 '30%'，表示柱子宽度的 30%）如果想要两个系列的柱子重叠，可以设置 barGap 为 '-100%'。这在用柱子做背景的时候有用。
          barGap: "-100%",
          // barMinHeight: 500,
          itemStyle: {
            normal: {
              color: "#134a61",
            },
          },
          //data: totalSeriesData,
          data: [],
        },
      ],
    });
    const options3 = ref({
      grid: {
        left: 50,
        right: 20,
        bottom: 90,
        top: 5,
        // grid 区域是否包含坐标轴的刻度标签。
        containLabel: false,
      },
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        //max: totalSeriesData[0],
        max: '',
      },
      yAxis: [
        {
          type: "category",
          // 是否是反向坐标轴
          inverse: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          //data: xAxisData,
          data: [],
          axisLabel: {
            padding: [0, 0, 20, 0],
            rich: {
              nt1: {
                color: "#fff",
                backgroundColor: "rgba(239,62,0,0.3)",
                borderColor: "#f03e00",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt2: {
                color: "#fff",
                backgroundColor: "rgba(233,186,21,0.3)",
                borderColor: "#eaba15",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt3: {
                color: "#fff",
                backgroundColor: "rgba(0,236,236,0.3)",
                borderColor: "#01e3e5",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
              nt: {
                color: "#fff",
                backgroundColor: "rgba(0,237,173,0.3)",
                borderColor: "#00edad",
                borderWidth: 1,
                width: 20,
                height: 20,
                fontSize: 14,
                align: "center",
                lineHeight: "20",
                padding: [2, 1, 1, 1],
              },
            },
            formatter: function (value, index) {
              let idx = index + 1;
              if (idx <= 3) {
                return ["{nt" + idx + "|" + idx + "}"].join("\n");
              } else {
                return ["{nt|" + idx + "}"].join("\n");
              }
            },
          },
        },
        {
          //名称
          type: "category",
          // Y 轴相对于默认位置的偏移，在相同的 position 上有多个 Y 轴的时候有用。
          offset: -10,
          position: "left",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "left",
            // 文字垂直对齐方式，默认自动。
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          //data: xAxisData,
          data: [],
        },
        {
          //名称
          type: "category",
          offset: 0,
          position: "right",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            align: "right",
            verticalAlign: "bottom",
            lineHeight: 25,
            fontSize: 12,
          },
          data: [],
        },
      ],
      series: [
        {
          zlevel: 1,
          type: "bar",
          barWidth: 10,
          // barGap: 50,
          //data: rankBarColor(detailData),
          data: '',
          // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
          label: {
            show: false,
          },
        },
        {
          type: "bar",
          barWidth: 10,
          // 不同系列的柱间距离，为百分比（如 '30%'，表示柱子宽度的 30%）如果想要两个系列的柱子重叠，可以设置 barGap 为 '-100%'。这在用柱子做背景的时候有用。
          barGap: "-100%",
          // barMinHeight: 500,
          itemStyle: {
            normal: {
              color: "#134a61",
            },
          },
          //data: totalSeriesData,
          data: [],
        },
      ],
    });
    const active = (e) => {
      paiming.value.active = e;
      if (paiming.value.active == 1) {
        options.value.yAxis[0].data = []
        options.value.yAxis[1].data = []
        options.value.yAxis[2].data = []
        options.value.xAxis.max = ''
        options.value.series[1].data = []
        options.value.series[0].data = ''
      } else if (paiming.value.active == 2) {

        options2.value.yAxis[0].data = []
        options2.value.yAxis[1].data = []
        options2.value.yAxis[2].data = []
        options2.value.xAxis.max = ''
        options2.value.series[1].data = []
        options2.value.series[0].data = ''

      } else {

        options3.value.yAxis[0].data = []
        options3.value.yAxis[1].data = []
        options3.value.yAxis[2].data = []
        options3.value.xAxis.max = ''
        options3.value.series[1].data = []
        options3.value.series[0].data = ''
      }


      getData();
    };
    const provinceId = getCurrentInstance()?.appContext.config.globalProperties.$provinceId;
    const getData = () => {

      if (paiming.value.active == 1) {
        http.get("/base_station/province/" + provinceId + "/sort-by/online-num").then((res) => {

          let total_num = 0;
          res.data.some((item) => {
            total_num += item.num
            // data.push({ name: getname[index], value: item.num, total: total_num })
            options.value.yAxis[0].data.push(item.cityName)
            options.value.yAxis[1].data.push(item.cityName)
            options.value.yAxis[2].data.push(`入网数：${item.num}个 `)
          });
          options.value.xAxis.max = total_num * 2;
          let list_num = []
          res.data.some((item) => {
            options.value.series[1].data.push(total_num * 2)
            list_num.push(item.num)
          });
          options.value.series[0].data = rankBarColor(list_num)

        });
      } else if (paiming.value.active == 2) {
        http.get("/base_station/province/" + provinceId + "/sort-by/power-rate-save").then((res) => {
          let total_num = 0;
          res.data.some((item) => {
            total_num += item.powerRateSaveTotal
            // data.push({ name: getname[index], value: item.num, total: total_num })
            options2.value.yAxis[0].data.push(item.stationName)
            options2.value.yAxis[1].data.push(item.stationName)
            options2.value.yAxis[2].data.push(`节省：${item.powerRateSaveTotal}元 `)
          });
          options2.value.xAxis.max = total_num * 2;
          let list_num = []
          res.data.some((item) => {
            options2.value.series[1].data.push(total_num * 2)
            list_num.push(item.powerRateSaveTotal)
          });
          options2.value.series[0].data = rankBarColor(list_num)

        });
      } else {
        http.get("/base_station/province/" + provinceId + "/sort-by/warning-num").then((res) => {
          let total_num = 0;
          res.data.some((item) => {
            total_num += item.warningNum
            // data.push({ name: getname[index], value: item.num, total: total_num })
            options3.value.yAxis[0].data.push(item.stationName)
            options3.value.yAxis[1].data.push(item.stationName)
            options3.value.yAxis[2].data.push(`警告数量：${item.warningNum} `)
          });
          options3.value.xAxis.max = total_num * 2;
          let list_num = []
          res.data.some((item) => {
            options3.value.series[1].data.push(total_num * 2)
            list_num.push(item.warningNum)
          });
          options3.value.series[0].data = rankBarColor(list_num)

        });
      }




    };
    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData();
    });

    return {
      options,
      options2,
      options3,
      active,
      paiming,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fx_content {
  position: relative;
  /*相对位置*/
  height: calc(100% - 15px);
}

.fenxi {
  background: url("@/assets/conbg.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}

.fenxi_con {
  width: 100%;
  position: absolute;
  height: 100%;
}

.title {
  color: #fff;
  font-size: 15px;
  padding: 5px 30px 10px 40px;
  font-weight: bold;
  background: url("@/assets/biaoti.png") 10px 5px;
  background-repeat: no-repeat;
}

.jjcon {
  height: calc(100% - 60px);
}

.paiming {
  color: #fff;
  font-size: 12px;
}

.paiming ul {
  display: flex;
}

.paiming ul li {
  display: flex;
  list-style: none;
  margin: 0 12px;
  background-color: #0c3568;
  padding: 3px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.paiming ul li.on {
  background-color: #409eff;
}
</style>
